import { Copy, Download, X, KeyRound } from "lucide-react";
import { toast } from "sonner";

export function BackupCodesDialog({ codes, open, onClose, title = "Your recovery codes" }) {
  if (!open) return null;

  const copyAll = () => {
    navigator.clipboard.writeText(codes.join("\n"));
    toast.success("Copied to clipboard");
  };
  const download = () => {
    const blob = new Blob(
      ["JTS Swanson — recovery codes\nStore these somewhere safe. Each code works once.\n\n" + codes.join("\n")],
      { type: "text/plain" }
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "jts-swanson-recovery-codes.txt";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" data-testid="backup-codes-dialog">
      <div className="card-surface rounded-2xl p-6 w-full max-w-md relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-white" data-testid="close-backup-codes">
          <X size={20} />
        </button>
        <div className="w-11 h-11 rounded-xl bg-[#C9A84A] flex items-center justify-center mb-4">
          <KeyRound className="text-[#0A0F1F]" size={22} />
        </div>
        <h3 className="font-serif font-bold text-xl text-white mb-1">{title}</h3>
        <p className="text-slate-400 text-sm mb-5">
          Save these codes somewhere safe. Each one can be used once if you lose access to your authenticator app.
        </p>
        <div className="grid grid-cols-2 gap-2 mb-5">
          {codes.map((c) => (
            <div key={c} className="bg-[#0A0F1F] border border-[#1E294B] rounded-lg py-2 text-center text-[#E5C158] font-mono tracking-wide">
              {c}
            </div>
          ))}
        </div>
        <div className="flex gap-3">
          <button onClick={copyAll} className="flex-1 card-surface hover:bg-[#18243F] rounded-xl py-2.5 text-white flex items-center justify-center gap-2 border border-[#1E294B]">
            <Copy size={16} /> Copy
          </button>
          <button onClick={download} className="flex-1 bg-[#C9A84A] hover:bg-[#E5C158] text-[#0A0F1F] font-bold rounded-xl py-2.5 flex items-center justify-center gap-2">
            <Download size={16} /> Download
          </button>
        </div>
      </div>
    </div>
  );
}
